import axios from 'axios';
import { Api } from 'application/interfaces/api';
import {
  CreateContactInput,
  CreateContactOutput,
} from 'application/interfaces/models/freshworksService';
import { AppError } from 'application/entities/app-error';

const freshworksService: Api['freshworksService'] = {
  createContact: async (
    payload: CreateContactInput,
  ): Promise<CreateContactOutput> => {
    const { GATSBY_SHIPA_API_BASE } = process.env;

    if (!GATSBY_SHIPA_API_BASE) {
      throw new AppError(
        'internalError',
        'GATSBY_SHIPA_API_BASE env variable is empty',
      );
    }

    try {
      const res = await axios.post<CreateContactOutput>(
        `${ GATSBY_SHIPA_API_BASE }/create-freshworks-contact`,
        payload,
      );

      return res?.data;
    } catch (error) {
      if (
        error?.response?.data
        && error?.response?.status >= 400
        && error?.response?.status < 500
      ) {
        throw new AppError(
          'internalError',
          JSON.stringify(error.response.data),
        );
      }

      throw new AppError(
        'serverError',
        'Server error. Please contact administrator.',
      );
    }
  },
};

export default freshworksService;
